export const Badge = {
  baseStyle: {
    px: '1.2rem',
    textTransform: 'none',
  },
}
